import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { MDXProvider } from "@mdx-js/react";
import { ReactNode } from "react";

import { ColorModeButton } from "#components/ColorModeButton";
import { FootnoteProvider } from "#components/Footnote";
import { components } from "#components/components";
import { theme } from "#components/theme";

import "#components/PageShell.css";

const Wrapper = ({ children }: { children: ReactNode }) => (
  <ChakraProvider theme={theme}>
    <ColorModeScript initialColorMode="system" />
    {/* @ts-expect-error: don't worry about it */}
    <MDXProvider components={components}>
      <FootnoteProvider>
        <ColorModeButton />
        {children}
      </FootnoteProvider>
    </MDXProvider>
  </ChakraProvider>
);

export default Wrapper;
